import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { FundingApplicationSchemas } from "api-types";
import { useLocation } from "react-router";

import { AIR_BANK_STATEMENT_UPDATE_API, FUNDING_APPLICATION_REVIEW_STATUS_API } from "../../components/constants";
import { handleCompletedCustomerTaskForSession } from "../../utils/completed-customer-task-for-session";

export const useAirBankStatementUpdateMutation = (customerDomain: string) => {
  const client = useAxios();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const mutationUrl = AIR_BANK_STATEMENT_UPDATE_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: FundingApplicationSchemas.AirBankStatementsUpdateParams) => {
      return client.post(mutationUrl, data);
    },
    onSuccess: (_, data: FundingApplicationSchemas.AirBankStatementsUpdateParams) => {
      queryClient.invalidateQueries({
        queryKey: [FUNDING_APPLICATION_REVIEW_STATUS_API.replace(":customerSlug", customerDomain)],
      });
      handleCompletedCustomerTaskForSession(data.airPublicId, pathname);
    },
  });
};
